import { Button } from "../../../components/Button";
import { TermsCheckbox } from "../../../components/form/TermsCheckbox";
import { StandardField } from "./StandardField";

export const RequestDemoForm = ({
  data,
  formData,
  changeData,
  errors,
  consent,
  changeConsent,
  handleSubmit,
  sending,
  classNameForTextAgreement,
}) => {
  return (
    <div className="form-container">
      <div className="form-header">
        <svg
          width="162"
          height="40"
          viewBox="0 0 162 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_14_353)">
            <path
              d="M45.3089 27.3512C51.0171 27.3512 54.4955 24.0774 54.4955 18.5119C54.4955 12.9464 51.0468 9.67263 45.3089 9.67263H39.2439V27.3214H45.3089V27.3512ZM45.1305 6.60715C53.1576 6.60715 57.9442 11.0714 57.9442 18.5417C57.9442 26.0119 53.1874 30.4762 45.1305 30.4762H37.6979C36.5682 30.4762 35.8547 29.7917 35.8547 28.6607V8.42263C35.8547 7.29168 36.5682 6.60715 37.6979 6.60715H45.1305Z"
              fill="#17009A"
            />
            <path
              d="M64.1578 20.3869H75.5445C74.9499 17.6786 72.8093 15.8929 69.866 15.8929C66.893 15.8929 64.7524 17.6786 64.1578 20.3869ZM78.5473 21.2202C78.5473 22.4702 77.804 23.1845 76.5553 23.1845H64.0686C64.5741 26.1012 66.7741 28.0357 70.0147 28.0357C72.1255 28.0357 73.7607 27.2024 74.7715 26.0119C75.0986 25.6548 75.485 25.4464 75.9905 25.4464C76.8824 25.4464 77.477 26.0417 77.477 26.9048C77.477 27.2321 77.3581 27.5298 77.1499 27.8274C75.5445 29.7321 73.0174 30.9226 70.0147 30.9226C64.4849 30.9226 60.7983 27.3214 60.7983 21.9941C60.7983 16.6964 64.4551 13.0655 69.8363 13.0655C74.8607 13.0655 78.5473 16.6369 78.5473 21.1905V21.2202Z"
              fill="#17009A"
            />
            <path
              d="M108.04 20.5952V28.9881C108.04 30.0298 107.475 30.6548 106.494 30.6548C105.513 30.6548 104.918 30 104.918 28.9881V20.9524C104.918 17.6488 103.521 15.8929 100.904 15.8929C98.1692 15.8929 96.5043 18.0357 96.5043 21.5179V28.9881C96.5043 30.0298 95.9394 30.6548 94.9286 30.6548C94.007 30.6548 93.4124 30 93.4124 28.9881V20.9524C93.4124 17.6488 92.015 15.8929 89.3691 15.8929C86.6339 15.8929 84.969 18.0357 84.969 21.5179V28.9881C84.969 30.0298 84.4041 30.6548 83.3933 30.6548C82.4419 30.6548 81.877 30 81.877 28.9881V14.9405C81.877 13.8691 82.4419 13.244 83.3933 13.244C84.3744 13.244 84.969 13.8691 84.969 14.9405V15.3571H85.0284C86.1285 13.8393 87.9123 13.006 90.0826 13.006C92.6097 13.006 94.4232 14.0476 95.4043 15.9524H95.4638C96.653 14.0774 98.6746 13.006 101.469 13.006C105.869 13.0357 108.04 15.6548 108.04 20.5952Z"
              fill="#17009A"
            />
            <path
              d="M128.018 14.9405V29.0774C128.018 34.3452 124.778 37.5 119.486 37.5C116.305 37.5 113.718 36.6072 112.291 34.7619C112.113 34.5238 111.964 34.1667 111.964 33.7798C111.964 32.9167 112.559 32.2917 113.48 32.2917C113.986 32.2917 114.253 32.4702 114.61 32.8274C115.769 33.9881 117.286 34.6429 119.367 34.6429C122.816 34.6429 124.867 32.5893 124.867 29.2262V27.7381H124.807C123.529 29.4941 121.478 30.4762 118.802 30.4762C114.105 30.4762 111.548 27.7083 111.548 22.5298V14.9405C111.548 13.8691 112.142 13.244 113.123 13.244C114.105 13.244 114.64 13.8691 114.64 14.9405V22.2024C114.64 25.7143 116.334 27.5893 119.545 27.5893C122.816 27.5893 124.867 25.2976 124.867 21.5774V14.9405C124.867 13.8691 125.462 13.244 126.413 13.244C127.453 13.244 128.018 13.8691 128.018 14.9405Z"
              fill="#17009A"
            />
            <path
              d="M139.286 20.3571C144.935 20.4167 146.927 21.9941 146.927 25.506C146.927 28.8988 144.162 30.8929 139.465 30.8929C135.867 30.8929 133.518 30.1786 131.854 28.631C131.556 28.3333 131.378 27.9464 131.378 27.5298C131.378 26.6369 131.972 26.0417 132.805 26.0417C133.191 26.0417 133.578 26.2202 133.935 26.4881C135.183 27.5595 137.027 28.125 139.227 28.125C142.11 28.125 143.805 27.1131 143.805 25.4464C143.805 23.9583 142.705 23.3333 138.959 23.3036C133.548 23.2738 131.556 21.8155 131.556 18.4524C131.556 15.1488 134.44 13.006 138.989 13.006C141.902 13.006 143.924 13.6012 145.559 14.9702C145.946 15.3274 146.124 15.7143 146.124 16.1905C146.124 17.1429 145.529 17.7679 144.667 17.7679C144.311 17.7679 143.983 17.6488 143.746 17.4405C142.408 16.3691 140.892 15.8333 139.197 15.8333C136.432 15.8333 134.648 16.875 134.648 18.4821C134.708 19.8214 135.718 20.3274 139.286 20.3571Z"
              fill="#17009A"
            />
            <path
              d="M161.822 27.7976C160.811 29.8512 158.789 30.8929 156.143 30.8929C152.159 30.8929 149.751 28.3631 149.751 24.1369V9.31547C149.751 8.2738 150.346 7.6488 151.327 7.6488C152.308 7.6488 152.843 8.2738 152.843 9.31547V13.4524H159.592C160.543 13.4524 161.108 14.0179 161.108 14.9107C161.108 15.8036 160.543 16.3393 159.592 16.3393H152.813V24.2262C152.813 26.6071 154.092 28.006 156.262 28.006C157.719 28.006 158.64 27.3512 159.354 26.2202C159.592 25.8631 159.949 25.5655 160.573 25.5655C161.376 25.5655 162 26.1607 162 27.0536C162 27.3214 161.941 27.5893 161.822 27.7976Z"
              fill="#17009A"
            />
            <path
              d="M24.1112 19.9702C24.022 21.5476 23.4274 23.3333 20.5139 24.2262C15.6381 25.7441 12.8435 29.1369 11.8029 30.1786C10.4948 31.4881 9.45421 33.3036 8.74069 35.8036C7.84878 38.8988 7.04606 40 4.22169 40C1.873 40 0 38.125 0 35.8036C0 33.4821 1.36759 31.9048 4.19196 31.6071C10.8515 30.8631 15.6976 26.4583 15.6976 20.0893V19.9107C15.6976 13.5417 10.8515 9.13691 4.19196 8.39286C1.36759 8.09524 0 6.51786 0 4.19643C0 1.875 1.873 0 4.19196 0C7.01633 0 8.32446 1.60714 8.77042 4.19643C9.12718 6.33929 10.465 8.5119 11.7732 9.82143C12.8435 10.8631 15.6084 14.256 20.4841 15.7738C23.3977 16.6964 23.9923 18.4524 24.0815 20.0298V19.9702H24.1112Z"
              fill="#17009A"
            />
            <path
              d="M3.0622 24.2262H3.95411C6.21361 24.2262 8.1758 22.5298 8.32445 20.2679C8.4731 17.8274 6.54064 15.8036 4.13249 15.8036C4.13249 15.8036 3.21086 15.7738 2.97301 15.8036C2.02165 15.8929 1.30812 16.5774 1.1892 17.5C1.01082 18.7798 1.01082 21.1607 1.1892 22.381C1.30812 23.3929 2.02165 24.1071 3.0622 24.2262Z"
              fill="#17009A"
            />
          </g>
          <defs>
            <clipPath id="clip0_14_353">
              <rect width="162" height="40" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div className="form-content">
        <h2 className="contact-form-header">
          Ready to see how external data can transform your business?
        </h2>
      </div>
      <div className="form-footer">
        <form onSubmit={handleSubmit}>
          <StandardField
            fields={data.fields}
            formData={formData}
            changeData={changeData}
            errors={errors}
            className="mt-7px"
            classNameTextArea="textarea-proper-request-demo mt-7px"
            labelClassName="input-label-style"
            hideRequiredLabel={true}
          />
          <section id="consent" />
          <TermsCheckbox
            text={data.form.consent}
            checked={consent}
            onChange={changeConsent}
            error={errors.consent}
            classNameForText={classNameForTextAgreement}
            classNameMain={"terms_checkbox-request-demo"}
            classNameContainer={"terms_checkbox-request-demo-container"}
            classNameError={"terms_checkbox-request-demo-error"}
          />
          <section>
            <Button demystIcon variant="secondary" disabled={sending} className="width-100">
              Book demo
            </Button>
          </section>
        </form>
      </div>
    </div>
  );
};
